<template>
	<DsStickyPanels
		scrollSnap="mandatory"
		:panels="panels"
		:sticky-header-offset="headerHeight"
	>
	</DsStickyPanels>
</template>

<script lang="ts" setup>
import DsStickyPanels from "components/sticky-panel/sticky-panels.vue";
import type { FactProps } from "components/fact-with-icon/fact-with-icon.vue";
import { type StickyPanelsProps, type StickyPanelsFact } from "./StickyPanels.types";
import { useStickyHeaderHeight } from "shared/composables/useStickyHeaderHeight";
const { headerHeight } = useStickyHeaderHeight();

const props = defineProps<StickyPanelsProps>();

const constructFactsFromViewModel = (facts: StickyPanelsFact[]) => {
	const factArr: FactProps[] = [];
	facts.forEach((fact) => {
		if (fact.icon) {
			factArr.push({
				brandIconName: fact.icon,
				text: fact.supportingText,
			});
		} else if (fact.stat) {
			factArr.push({
				stat: fact.stat,
				text: fact.supportingText,
			});
		}
	});
	return factArr;
};

const panels = props.vm.baseViewModel.stickyPanelBlocks.map((panel) => {
	return {
		facts: constructFactsFromViewModel(panel.facts),
		image: panel.imageUrl,
		imageAlt: panel.imageAltText,
		linkIsExternal: panel.link?.isExternal,
		linkText: panel.link?.text,
		linkUrl: panel.link?.url,
		title: panel.title,
		text: panel.description,
	}
});
</script>
